var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "126px",
    viewBox: "0 0 150 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.44424438%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-blob-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17EAD9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6078EA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paid-courses",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.4703125
  }, /*#__PURE__*/React.createElement("g", {
    id: "payment-final-stage,-input-details",
    transform: "translate(-1042.000000, -815.000000)",
    fill: "url(#linearGradient-blob-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-+-Path-6-+-Path-8-Mask",
    transform: "translate(261.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.505104,787.120626 C932.799891,771.529027 874.765137,748.602114 903.912195,712.087069 C933.059254,675.572025 910.6084,621.012804 875.619272,643.004238 C840.630144,664.995672 882.103603,666.811129 823.674727,694.948783 C765.245851,723.086437 808.210316,802.712225 870.505104,787.120626 Z",
    id: "Oval",
    transform: "translate(856.663465, 713.532298) rotate(93.000000) translate(-856.663465, -713.532298) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob2);
export default __webpack_public_path__ + "static/media/blob_2.eee687231240e73d92d645c33b9971e1.svg";
export { ForwardRef as ReactComponent };